import React from 'react';
import Layout from '../../components/layout/layout';

export default function ConfidentialitePage() {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold mb-6">Politique de confidentialité</h1>
        <div className="prose max-w-none">
          <p className="text-lg mb-4">Page en construction</p>
        </div>
      </div>
    </Layout>
  );
}